export const _setAlertDate = (state, action) => {
  state.alertDate = action.payload;
};

export const _setCbpProgram = (state, action) => {
  state.cbpProgram = action.payload;
};

export const _setCbpContact = (state, action) => {
  state.cbpContact = action.payload;
};

export const _setDischargeReason = (state, action) => {
  state.dischargeReason = action.payload;
};

  export const _setAlertDischOthRsn = (state, action) => {
    state.alertDischOthRsn = action.payload;
  };

  export const _setAlertAptType = (state, action) => {
    state.alertAptType = action.payload;
  };

  export const _setMissedAppointmentOn = (state, action) => {
    state.missedAppointmentOn = action.payload;
  };

  export const _setAlertAptTypOth = (state, action) => {
    state.alertAptTypOth = action.payload;
  };

  export const _setAdmissionMode = (state, action) => {
    state.admissionMode = action.payload;
  };

  export const _setAdmittedToProgramOn = (state, action) => {
    state.admittedToProgramOn = action.payload;
  };

  export const _setAlertAthType = (state, action) => {
    state.alertAthType = action.payload;
  };

  export const _setDischargeMode = (state, action) => {
    state.dischargeMode = action.payload;
  };

  export const _setDichargedFromProgramOn = (state, action) => {
    state.dichargedFromProgramOn = action.payload;
  };

  export const _setUrinalysisFor = (state, action) => {
    state.urinalysisFor = action.payload;
  };

  export const _setAlertUADate = (state, action) => {
    state.alertUADate = action.payload;
  };

  export const _setEmergencyMedicalCareAt = (state, action) => {
    state.emergencyMedicalCareAt = action.payload;
  };

  export const _setAlertEmerCareDate = (state, action) => {
    state.alertEmerCareDate = action.payload;
  };

  export const _setBehavioralOrTreatmentCaseConference = (state, action) => {
    state.BehavioralOrTreatmentCaseConference = action.payload;
  };

  export const _setComment = (state, action) => {
    state.comment = action.payload;
  };
